// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__1WAn9","question":"Question_question__29fX3","description":"Question_description__168zJ"};